import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';

const props = withCompInfo<any, any>()(['compData'], ({ compData }) => {
  return {
    ...{ skin: 'light' },
    ...compData,
  };
});

export const css = withCompInfo()([], () => {
  return {
    height: 'auto',
  };
});

export default createComponentMapperModel({
  props,
  css,
});
